export default __webpack_public_path__ + "static/media/Malaki_Home.3fbc1df0.webp";